import React, { useEffect } from "react";
import { createPortal } from "react-dom";

// Style
import "./Modals.scss";

// components
import Crop from "./Crop";
import Bunner from "./Banner";
import Success from "./Success";
import Confirm from "./Confirm";
import Redirect from "./Redirect";
import ProjectAdd from "./ProjectAdd";
import DownloadSDF from './DownloadSDF';
import ProjectsList from "./ProjectsList";
import LimitExceeded from "./LimitExceeded";
import ProjectUpdate from "./ProjectUpdate";
import Button from "components/UiKit/Button";

// Lib
import { shallowEqual } from "react-redux";
import { getDriverInstance } from "lib/driver";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// Actions
import * as actionCreators from "reducers/modal";

// Type
type ModalComponents = {
  [key: string]: React.ComponentType<any>
};

export const ModalComponent = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((store) => store.modal, shallowEqual);

  const modalProps = modal?.modalProps;
  const openModal = modal.openModal || false;
  const className = modalProps?.className || "";

  useEffect(() => {
    window.addEventListener("click", handleClick);

    return () => window.removeEventListener("click", handleClick);
  }, []);

  const COMPONENT: ModalComponents = {
    "crop": Crop,
    "bunner": Bunner,
    "success": Success,
    "confirm": Confirm,
    "redirect": Redirect,
    "projectAdd": ProjectAdd,
    'downloadSDF': DownloadSDF,
    "projectsList": ProjectsList,
    "projectUpdate": ProjectUpdate,
    "limitExceeded": LimitExceeded,
  };

  const modalType = modal?.modalProps?.type as keyof ModalComponents;
  const ModalComponent = COMPONENT[modalType];

  const onClose = () => {
    dispatch(actionCreators.modalClose());
  };

  const modalActions = {
    closeCallback: onClose
  };

  const handleClick = (e: any) => {
    if (e.target.classList.contains("overlay")) {
      onClose();
    }
  };

  const mountElement = document.getElementById("overlay");

  if (!openModal || !mountElement) return null;

  return createPortal(
    <div className="overlay">
      <div className="relative">
        {modalType !== "confirm" && (
          <Button
            isSvg
            icon="crossSvg"
            variable="icon"
            onPress={onClose}
            className="overlay__cross"
          />
        )}
        <ModalComponent
          className={className}
          actions={modalActions}
          modalProps={modalProps}
        />
      </div>
    </div>,
    mountElement
  );
};

export default ModalComponent;
